import { render, staticRenderFns } from "./VServiceCard.vue?vue&type=template&id=47b531ee&scoped=true"
import script from "./VServiceCard.vue?vue&type=script&lang=js"
export * from "./VServiceCard.vue?vue&type=script&lang=js"
import style0 from "./VServiceCard.vue?vue&type=style&index=0&id=47b531ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b531ee",
  null
  
)

export default component.exports